import { DEFAULT_EMPTY_VALUE } from 'src/constants/companyReport';

interface Props {
  match: string;
}

function LikelyHood({ match }: Props) {
  return match ? (
    <p
      className={
        'badge badge-pill text-white py-1 px-3 badge-color-' +
        match.toLowerCase().replace(/\s/g, DEFAULT_EMPTY_VALUE)
      }
    >
      {match}
    </p>
  ) : (
    <p className="badge badge-pill text-black py-1 px-3 badge-color-no-match"> No Match </p>
  );
}

export default LikelyHood;
